
import { change } from 'redux-form';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { getBookingSubCategories as query } from "../../../lib/graphql";

export const getBookingSubCategories = (variables, loaderName) => {

    try {
        return async (dispatch, getState, { client }) => {

           dispatch(change("ManualBookingForm",`loaders.${loaderName}`, true));
            await dispatch(change("ManualBookingForm", 'subCategories', null));
            const { data } = await client.query({
                query,
                variables,
                fetchPolicy: 'network-only'
            });

            if (data?.getBookingSubCategories?.status == 200 && data?.getBookingSubCategories?.results?.length > 0) {
                await dispatch(change("ManualBookingForm", 'subCategories', data?.getBookingSubCategories?.results));
            }

            dispatch(change("ManualBookingForm",`loaders.${loaderName}`, false));
            dispatch(change('ManualBookingForm', 'stepTwoCompleted', true));

        }

    } catch (error) {
        dispatch(change("ManualBookingForm",`loaders.${loaderName}`, false));
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
        return false;
    }
}
